import * as React from "react";
import BackLink from "../../../components/atoms/BackLink";
import Loader from "../../../components/atoms/Loader";
import { StaffBoardPostEditForm } from "../../../components/features/StaffBoardPostEditForm";
import { useFetchStaffBoardPost } from "../../../hooks/http/useFetchStaffBoardPost";
import { useQueryError } from "../../../hooks/http/useQueryError";
import OperatorInterface from "../../../interfaces/OperatorInterface";
import SectionInterface from "../../../interfaces/SectionInterface";

interface Props {
  section: SectionInterface;
  currentOperator: OperatorInterface;
  staffBoardPostId: string;
}

const SectionsStaffBoardPostEdit = (props: Props) => {
  const { section, currentOperator, staffBoardPostId } = props;

  const { isPending, data, error } = useFetchStaffBoardPost({
    sectionId: section.id,
    staffBoardPostId,
    disableCache: true, // キャッシュがあると、フォームに変更前の内容が表示されることがあるので無効化する
  });
  useQueryError(error);

  return (
    <React.Fragment>
      <BackLink>戻る</BackLink>
      {isPending || !data ? (
        <Loader loading />
      ) : (
        <StaffBoardPostEditForm
          sectionId={section.id}
          staffBoardPost={data}
          operatorName={currentOperator.fullName}
        />
      )}
    </React.Fragment>
  );
};

export default SectionsStaffBoardPostEdit;
